
export const paperMain = (isMobile) => ({
  p: isMobile ? 2 : 4,
  mb: isMobile ? 2 : 4,
  border: '1px solid #e0e0e0',
  borderRadius: 2,
  backgroundColor: 'white',
});

export const paperInfo = (isMobile) => ({
  p: isMobile ? 2 : 4,
  mb: isMobile ? 2 : 4,
  border: '1px solid #e0e0e0',
  borderRadius: 2,
  backgroundColor: '#fafafa',
});

export const paperFile = {
  border: '1px solid #e0e0e0',
  borderRadius: 2,
  overflow: 'hidden',
};

export const pdfToolbar = {
  p: 2,
  borderBottom: '1px solid #e0e0e0',
  bgcolor: 'grey.50',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const pdfContainer = (isFullscreen) => ({
  height: isFullscreen ? '80vh' : 'auto',
  minHeight: isFullscreen ? 'auto' : '60vh',
  maxHeight: isFullscreen ? 'auto' : '80vh',
  bgcolor: 'white',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  overflow: 'auto',
  p: 2,
});

export const pdfPager = {
  p: 2,
  borderTop: '1px solid #e0e0e0',
  backgroundColor: '#f8f9fa',
  display: 'flex',
  justifyContent: 'center',
  gap: 2,
};
